import React from 'react';
import { scroller } from 'react-scroll';
// Custom
import { getHocDisplayName } from 'utils/Tools';

const scrollerOptions = {
  errorDisplayer: {
    duration: 500,
    delay: 50,
    smooth: true,
    offset: -76,
  },
  subForm: {
    duration: 300,
    delay: 10,
    smooth: true,
    offset: -108,
  },
};

const handleScrollTo = (elementName, target) => {
  scroller.scrollTo(`${target}_${elementName}`, scrollerOptions[target]);
};

const withScrollerManagement = (WrappedComponent) => {
  const WithScrollerManagement = (props) => (
    <WrappedComponent
      handleScrollTo={handleScrollTo}
      {...props}
    />
  );

  WithScrollerManagement.displayName = getHocDisplayName('WithScrollerManagement', WrappedComponent);

  return WithScrollerManagement;
};

export default withScrollerManagement;



// WEBPACK FOOTER //
// ./hocs/WithScrollerManagement.js